import gql from 'graphql-tag'

export default gql`
query getregistrationCount($slug: String, $department: String){
  registrationCount(filter: {
    AND:[{slug : $slug},{profile:{department: $department}}]
  })
}
`
